import type { IconData } from '@stacksjs/iconify-core'

export const devicesComputer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.84.65H.16v11.76H8a2.94 2.94 0 0 0-2.94 2.94h5.88A2.94 2.94 0 0 0 8 12.41h7.84z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesComputer
